// eslint-disable-next-line import/prefer-default-export
export function notEmpty(root: string, obj: Record<string, string | number | object | undefined>) {
  Object.entries(obj).forEach(([key, value]) => {
    if (!value) {
      throw Error(`Config ${root}.${key} is not specified`);
    }
    if (value instanceof Object) {
      notEmpty(`${root}.${key}`, value as Record<string, string | object>);
    }
  });
  return obj;
}
